import {useContext, useMemo, useState} from "react";
import {Checkbox, ListItemText, Menu, MenuItem} from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {SmallGreyButton} from "../../../../misc/SmallGreyButton";
import {HardwareViewModeContext} from "./HardwareViewMode";
import {phaseOptions} from "../../../../misc/Phase";

export function HardwarePhaseFilter() {
    const ctx = useContext(HardwareViewModeContext);
    const [anchor, setAnchor] = useState<HTMLElement | null>(null);
    const options = useMemo(() => phaseOptions(ctx.phaseOptions), [ctx.phaseOptions]);

    // a phase in the url that no opening has is ignored
    const selected = ctx.phaseFilter.filter(id => options.some(o => o.id === id));

    const toggle = (id: string) => {
        ctx.setPhaseFilter(selected.includes(id) ? selected.filter(v => v !== id) : [...selected, id]);
    };

    return (
        <>
            <SmallGreyButton startIcon={<FilterListIcon />} endIcon={<ArrowDropDownIcon />} onClick={e => setAnchor(e.currentTarget)}>
                {selected.length === 0 ? "Phase" : "Phase: " + options.filter(o => selected.includes(o.id)).map(o => o.label.replace(/^Phase /, "")).join(", ")}
            </SmallGreyButton>
            {anchor && <Menu open anchorEl={anchor} onClose={() => setAnchor(null)}>
                <MenuItem dense onClick={() => ctx.setPhaseFilter([])}>
                    <Checkbox size="small" checked={selected.length === 0} />
                    <ListItemText primary="All phases" />
                </MenuItem>
                {options.map(o => (
                    <MenuItem key={o.id} dense onClick={() => toggle(o.id)}>
                        <Checkbox size="small" checked={selected.includes(o.id)} />
                        <ListItemText primary={o.label} />
                    </MenuItem>
                ))}
            </Menu>}
        </>
    )
}
